// Journeys: pure helpers for the pricing iframe <-> parent hand-off (contract §2). No React, no
// browser globals, so the decisions here (what to trust, what to forward) are unit-testable.

// The only iframe events the parent forwards. Anything else is ignored.
export const FORWARDED_IFRAME_EVENTS = ['pricing_iframe_rendered', 'plan_clicked', 'checkout_error', 'auth_timeout']

const STRIPE_SESSION_RE = /(cs_(?:live|test)_[A-Za-z0-9]+)/

/** The `cs_…` Checkout Session id found in a string (message field or Stripe URL), or ''. */
export function stripeSessionIdFrom(value) {
  try {
    const m = typeof value === 'string' ? value.match(STRIPE_SESSION_RE) : null
    return m ? m[1] : ''
  } catch (_) {
    return ''
  }
}

/** attemptId for `redirect_to_stripe`: the iframe's checkoutSessionId, else the id inside the URL. */
export function redirectAttemptId(data) {
  try {
    return stripeSessionIdFrom(data && data.checkoutSessionId) || stripeSessionIdFrom(data && data.url)
  } catch (_) {
    return ''
  }
}

/** Flat, primitive-only, at most 8 entries: iframe-supplied props are data, never trusted structure. */
export function flatPrimitiveProps(props) {
  const out = {}
  try {
    if (!props || typeof props !== 'object') return out
    Object.keys(props).slice(0, 8).forEach((k) => {
      const v = props[k]
      if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') out[k] = v
    })
  } catch (_) {
    /* ignore */
  }
  return out
}

/**
 * Decide whether a PRICING_COMPONENT_EVENT message becomes a funnel event.
 * Only when the message really came from OUR iframe's window (event.source === iframe.contentWindow)
 * and the name is one of FORWARDED_IFRAME_EVENTS. Returns { name, fields } for trackFunnel, or null.
 * The parent's own context (feature, surface, codebase) always wins over anything the iframe sent.
 */
export function iframeEventToFunnel(data, context) {
  try {
    // unpacked inside the try: a missing/null context returns null instead of throwing into the caller
    const { eventSource, iframeWindow, feature, surface } = context || {}
    if (!data || data.type !== 'PRICING_COMPONENT_EVENT') return null
    if (!eventSource || !iframeWindow || eventSource !== iframeWindow) return null
    if (!FORWARDED_IFRAME_EVENTS.includes(data.name)) return null
    return {
      name: data.name,
      fields: {
        props: {
          ...flatPrimitiveProps(data.props),
          feature: feature || '',
          surface: surface || 'modal',
          codebase: 'dashboard',
        },
        // The dashboard never knows an aiLogId (the builder's /playground-ai does).
        aiLogId: '',
      },
    }
  } catch (_) {
    return null
  }
}
